import Criteria from '../views/profileScoring/Index'
import ListCriteria from '../views/profileScoring/List'
import Permissions from '@/permissions'

export const profileScoringRouters = {
  path: 'profile-scoring',
  component: Criteria,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.profileScoring.manage],
    groups: 'profileScoring'
  },
  children: [
    {
      path: '',
      name: 'list-criteria',
      component: ListCriteria,
      meta: {
        permissions: [
          Permissions.backend.profileScoring.list
        ],
        groups: 'profileScoring',
        breadcrumb: [
          {
            name_en: 'Profile Scoring',
            name_km: 'រវ្វាយតម្លៃពិន្ទុ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    }
  ]
}
